import type {MakeRequest, RestResponse} from './request'
import type {ServiceDataResponse} from '../models'
import {dataResponseConverter} from './request'

export class PaymentsApi {
  constructor(private makeRequest: MakeRequest) {}

  fetchPrices = (payload: {
    categoryId: number
    countryIso: number
  }): Promise<RestResponse<ServiceDataResponse>> => {
    return this.makeRequest.newRequest<ServiceDataResponse>(
      {
        endpoint: `v2/payments/prices`,
        body: payload,
      },
      dataResponseConverter,
    )
  }
}
